import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NotificationService } from 'src/app/Service/notification.service';
import { Router } from '@angular/router';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { OtherService } from 'src/app/Service/other.service';
import axios from 'src/app/Service/axios';
import Chart from 'chart.js/auto';
import {
  SafetyVehicle,
  SafetyStatus,
  STATUS_MAP,
  SafetyVehicleModalComponent,
} from './components/safety-vehicle-modal/safety-vehicle-modal.component';

@Component({
  selector: 'app-telemetry-safety-dashboard',
  templateUrl: './telemetry-safety-dashboard.component.html',
  styleUrls: ['./telemetry-safety-dashboard.component.css'],
})
export class TelemetrySafetyDashboardComponent implements OnInit {
  mdl_Request: FormGroup = this.FormBuilder.group({
    iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),
    strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),
  });

  vehicles: SafetyVehicle[] = [];

  todayDate = 'امروز';
  lastUpdate = '—';

  searchTerm = '';
  statusFilter: 'all' | 'safe' | 'warning' | 'danger' | 'critical' = 'all';

  visibleVehicles: SafetyVehicle[] = [];

  @ViewChild(SafetyVehicleModalComponent) vehicleModal!: SafetyVehicleModalComponent;

  tableColumns: { field: keyof SafetyVehicle; label: string }[] = [
    { field: 'strUnitID', label: 'نام خودرو' },
    { field: 'SafetyIndex', label: 'شاخص ایمنی' },
    { field: 'AcceleratorScore', label: 'امتیاز شتاب‌گیری' },
    { field: 'TorqueScore', label: 'امتیاز گشتاور' },
    { field: 'SpeedScore', label: 'امتیاز سرعت' },
    { field: 'StopGoScore', label: 'امتیاز توقف و حرکت' },
    { field: 'MaxSpeed', label: 'حداکثر سرعت' },
    { field: 'TotalRiskEvents', label: 'تعداد کل رویدادهای پرخطر' },
    { field: 'TotalHighEvents', label: 'تعداد رویدادهای پرخطر' },
    { field: 'TotalVeryHighEvents', label: 'تعداد رویدادهای بسیار پرخطر' },
    { field: 'AcceleratorEvents', label: 'رویدادهای شتاب‌گیری' },
    { field: 'TorqueEvents', label: 'رویدادهای گشتاور' },
    { field: 'dtSDateTime', label: 'زمان شروع' },
    { field: 'dtEDateTime', label: 'زمان پایان' },
  ];

  summaryCards = [
    {
      title: 'میانگین شاخص ایمنی ناوگان',
      value: '—',
      desc: 'میانگین کل خودروها',
      icon: 'fa-shield',
      cls: 'info',
    },
    {
      title: 'تعداد خودروها',
      value: '۰',
      desc: 'کل ناوگان',
      icon: 'fa-car',
      cls: 'info',
    },
    {
      title: 'خودروهای نیازمند توجه',
      value: '۰',
      desc: 'شاخص ایمنی کمتر از ۸۰',
      icon: 'fa-exclamation-triangle',
      cls: 'warning',
    },
    {
      title: 'خودروهای پرخطر',
      value: '۰',
      desc: 'شاخص ایمنی کمتر از ۶۰',
      icon: 'fa-warning',
      cls: 'danger',
    },
    {
      title: 'مجموع رویدادهای پرخطر',
      value: '۰',
      desc: 'کل رویدادهای ثبت‌شده',
      icon: 'fa-exclamation-circle',
      cls: 'critical',
    },
  ];

  distributionLegend: { label: string; count: number; color: string }[] = [];
  attentionList: SafetyVehicle[] = [];
  topRiskList: SafetyVehicle[] = [];

  private distributionChart: any = null;
  private radarChart: any = null;

  constructor(
    private _tooltip: NotificationService,
    private FormBuilder: FormBuilder,
    private router: Router,
    private gurdService: GurdServiceService,
    private _otherService: OtherService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    Chart.defaults.font.family = "'vazir', Tahoma, sans-serif";
    const today = new Date();
    this.todayDate = today.toLocaleDateString('fa-IR', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
    this.getDashboardData();
  }

  async getDashboardData() {
    try {
      this._otherService.Showspinner();
      const raw = (
        await axios.post(
          `CAN_GetSafetyIndex`,
          this._otherService.stringNumberToNumber(this.mdl_Request.value),
        )
      ).data;
      this._otherService.nonespinner();

      let response: any;
      try {
        response = typeof raw === 'string' ? JSON.parse(raw.toString()) : raw;
        if (typeof response === 'string') response = JSON.parse(response);
        if (response && typeof response.data === 'string') {
          try {
            response = JSON.parse(response.data);
          } catch {}
        }
      } catch {
        response = raw;
      }

      if (response?.ISSessionExpired == true) {
        this._tooltip.showError('نشست کاربری شما منقضی شده است');
        this._otherService.removeLocalStorage();
        this.router.navigate(['login'], {
          queryParams: { error: 'CAN_GetSafetyIndex' },
        });
        return;
      }

      if (response?.iResult == 0) {
        this._tooltip.showError(response.strError || 'خطا در دریافت اطلاعات');
        return;
      }

      const table: SafetyVehicle[] =
        response?.Table ?? response?.table ?? response?.TABLE ?? [];
      this.vehicles = Array.isArray(table) ? table : [];

      this.lastUpdate = new Date().toLocaleTimeString('fa-IR', {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      });

      this.refreshDerived();
      this.applyTableView();
      this.cdr.detectChanges();
      this.renderCharts();
    } catch (err) {
      this._otherService.nonespinner();
      console.error('[SafetyDashboard] getDashboardData error', err);
      this._tooltip.showError('خطا در دریافت اطلاعات داشبورد ایمنی');
    }
  }

  refresh(): void {
    this.getDashboardData();
  }

  // ---------- وضعیت ----------
  getStatus(safetyIndex: number | null | undefined): SafetyStatus {
    if (safetyIndex === null || safetyIndex === undefined)
      return STATUS_MAP['critical'];
    if (safetyIndex >= 80) return STATUS_MAP['safe'];
    if (safetyIndex >= 60) return STATUS_MAP['warning'];
    if (safetyIndex >= 40) return STATUS_MAP['danger'];
    return STATUS_MAP['critical'];
  }

  getRowClass(v: SafetyVehicle): string {
    const s = v.SafetyIndex ?? 0;
    if (s < 40) return 'row-critical';
    if (s < 60) return 'row-high';
    if (s < 80) return 'row-warning';
    return '';
  }

  vehicleName(v: SafetyVehicle): string {
    return v.strFullName || v.strUnitID || '—';
  }

  private refreshDerived(): void {
    const total = this.vehicles.length;
    const avgSafety = total ? this.vehicles.reduce((s, v) => s + (v.SafetyIndex ?? 0), 0) / total : 0;
    const totalRiskEvents = this.vehicles.reduce((s, v) => s + (v.TotalRiskEvents ?? 0), 0);
    const attentionCount = this.vehicles.filter((v) => (v.SafetyIndex ?? 0) < 80).length;
    const dangerCount = this.vehicles.filter((v) => (v.SafetyIndex ?? 0) < 60).length;
    const safeCount = this.vehicles.filter((v) => (v.SafetyIndex ?? 100) >= 80).length;
    const warningCount = this.vehicles.filter((v) => (v.SafetyIndex ?? 0) >= 60 && (v.SafetyIndex ?? 0) < 80).length;
    const criticalCount = this.vehicles.filter((v) => (v.SafetyIndex ?? 0) < 40).length;
    const dangerOnlyCount = this.vehicles.filter((v) => (v.SafetyIndex ?? 0) >= 40 && (v.SafetyIndex ?? 0) < 60).length;

    const avgCls = 
          avgSafety >= 80 ? 'safe'
        : avgSafety >= 60 ? 'warning'
        : avgSafety >= 40 ? 'danger'
        : 'critical';

    this.summaryCards = [
      {
        title: 'میانگین شاخص ایمنی ناوگان',
        value: Number(avgSafety.toFixed(1)).toLocaleString('fa-IR'),
        desc: 'میانگین کل خودروها',
        icon: 'fa-shield',
        cls: avgCls,
      },
      {
        title: 'تعداد خودروها',
        value: total.toLocaleString('fa-IR'),
        desc: 'کل ناوگان',
        icon: 'fa-car',
        cls: 'info',
      },
      {
        title: 'خودروهای نیازمند توجه',
        value: attentionCount.toLocaleString('fa-IR'),
        desc: 'شاخص ایمنی کمتر از ۸۰',
        icon: 'fa-exclamation-triangle',
        cls: 'warning',
      },
      {
        title: 'خودروهای پرخطر',
        value: dangerCount.toLocaleString('fa-IR'),
        desc: 'شاخص ایمنی کمتر از ۶۰',
        icon: 'fa-warning',
        cls: 'danger',
      },
      {
        title: 'مجموع رویدادهای پرخطر',
        value: totalRiskEvents.toLocaleString('fa-IR'),
        desc: 'کل رویدادهای ثبت‌شده',
        icon: 'fa-exclamation-circle',
        cls: 'critical',
      },
    ];

    this.distributionLegend = [
      { label: 'ایمن (۸۰-۱۰۰)', count: safeCount, color: '#2ecc71' },
      { label: 'نیازمند توجه (۶۰-۸۰)', count: warningCount, color: '#f1c40f' },
      { label: 'پرخطر (۴۰-۶۰)', count: dangerOnlyCount, color: '#e74c3c' },
      {
        label: 'بسیار پرخطر (کمتر از ۴۰)',
        count: criticalCount,
        color: '#b03a2e',
      },
    ];

    this.attentionList = this.vehicles
      .filter((v) => (v.SafetyIndex ?? 100) < 80)
      .sort((a, b) => (a.SafetyIndex ?? 0) - (b.SafetyIndex ?? 0));

    this.topRiskList = [...this.vehicles]
      .sort((a, b) => (b.TotalRiskEvents ?? 0) - (a.TotalRiskEvents ?? 0))
      .filter((v) => (v.TotalRiskEvents ?? 0) > 0)
      .slice(0, 10);
  }

  // ---------- جدول: فیلتر ----------
  applyTableView(): void {
    let list = [...this.vehicles];
    const q = this.searchTerm.trim().toLowerCase();
    if (q) {
      list = list.filter((v) => this.vehicleName(v).toLowerCase().includes(q) ||
          (v.strVehicleNo || '').toLowerCase().includes(q) ||
          (v.strUnitID || '').toLowerCase().includes(q),
      );
    }
    if (this.statusFilter !== 'all') {
      list = list.filter((v) => {
        const s = v.SafetyIndex ?? 0;
        if (this.statusFilter === 'safe') return s >= 80;
        if (this.statusFilter === 'warning') return s >= 60 && s < 80;
        if (this.statusFilter === 'danger') return s >= 40 && s < 60;
        return s < 40;
      });
    }
    this.visibleVehicles = list;
  }

  selectVehicle(unitId: string): void {
    const v = this.vehicles.find((x) => x.strUnitID === unitId);
    if (v && this.vehicleModal) {
      this.vehicleModal.open(v);
    }
  }

  trackByUnitId(_: number, item: SafetyVehicle): string {
    return item.strUnitID;
  }

  // ---------- فرمت ----------
  toFa(n: number | null | undefined): string {
    if (n === null || n === undefined) return '—';
    return n.toLocaleString('fa-IR');
  }

  formatDate(dateStr: string | null | undefined): string {
    if (!dateStr) return '—';
    try {
      const d = new Date((dateStr as string).replace(' ', 'T'));
      if (isNaN(d.getTime())) return dateStr as string;
      return (d.toLocaleDateString('fa-IR') + ' ' + d.toLocaleTimeString('fa-IR', { hour: '2-digit', minute: '2-digit' }));
    } catch {
      return dateStr as string;
    }
  }

  // ---------- نمودارها ----------
  private renderCharts(): void {
    setTimeout(() => {
      this.renderDistributionChart();
      this.renderRadarChart();
    }, 50);
  }

  private renderDistributionChart(): void {
    const canvas = document.getElementById('safetyDistributionChart') as HTMLCanvasElement | null;
    if (!canvas) return;
    if (this.distributionChart) {
      this.distributionChart.destroy();
      this.distributionChart = null;
    }
    const data = this.distributionLegend.map((d) => d.count);
    if (!data.some((d) => d > 0)) {
      return;
    }
    this.distributionChart = new Chart(canvas, {
      type: 'doughnut',
      data: {
        labels: this.distributionLegend.map((d) => d.label),
        datasets: [
          {
            data,
            backgroundColor: this.distributionLegend.map((d) => d.color),
            borderColor: '#0b0f14',
            borderWidth: 3,
            hoverOffset: 8,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        cutout: '65%',
        plugins: {
          legend: { display: false },
          tooltip: {
            backgroundColor: '#111a22',
            borderColor: '#2a3a48',
            borderWidth: 1,
            titleColor: '#e0e9f2',
            bodyColor: '#b0c2d4',
            cornerRadius: 12,
            padding: 12,
            titleFont: { family: "'vazir', Tahoma, sans-serif" },
            bodyFont: { family: "'vazir', Tahoma, sans-serif" },
            callbacks: {
              label: (context: any) => {
                const total = (context.dataset.data as number[]).reduce(
                  (a: number, b: number) => a + b,
                  0,
                );
                const pct = total > 0 ? ((context.parsed / total) * 100).toFixed(1) : '0';
                return ` ${context.label}: ${context.parsed} خودرو (${pct}٪)`;
              },
            },
          },
        },
      },
    });
  }

  private renderRadarChart(): void {
    const canvas = document.getElementById('radarChart') as HTMLCanvasElement | null;
    if (!canvas) return;
    const vehicle = this.vehicles[0];
    if (!vehicle) return;
    if (this.radarChart) {
      this.radarChart.destroy();
      this.radarChart = null;
    }
    this.radarChart = new Chart(canvas, {
      type: 'radar',
      data: {
        labels: [
          'امتیاز شتاب‌گیری',
          'امتیاز گشتاور',
          'امتیاز سرعت',
          'امتیاز توقف و حرکت',
          'شاخص ایمنی نهایی',
        ],
        datasets: [
          {
            label: this.vehicleName(vehicle),
            data: [
              vehicle.AcceleratorScore ?? 0,
              vehicle.TorqueScore ?? 0,
              vehicle.SpeedScore ?? 0,
              vehicle.StopGoScore ?? 0,
              vehicle.SafetyIndex ?? 0,
            ],
            backgroundColor: 'rgba(74, 158, 255, 0.15)',
            borderColor: '#4a9eff',
            borderWidth: 2,
            pointBackgroundColor: '#4a9eff',
            pointBorderColor: '#0b0f14',
            pointRadius: 4,
            pointHoverRadius: 6,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          r: {
            beginAtZero: true,
            max: 100,
            ticks: {
              stepSize: 20,
              color: '#6f8397',
              backdropColor: 'transparent',
              font: { size: 9, family: "'vazir', Tahoma, sans-serif" },
            },
            grid: { color: '#1f2f3c' },
            angleLines: { color: '#1f2f3c' },
            pointLabels: {
              color: '#b0c2d4',
              font: { size: 10, family: "'vazir', Tahoma, sans-serif" },
            },
          },
        },
        plugins: {
          legend: { display: false },
          tooltip: {
            backgroundColor: '#111a22',
            borderColor: '#2a3a48',
            borderWidth: 1,
            titleColor: '#e0e9f2',
            bodyColor: '#b0c2d4',
            cornerRadius: 12,
            padding: 12,
            titleFont: { family: "'vazir', Tahoma, sans-serif" },
            bodyFont: { family: "'vazir', Tahoma, sans-serif" },
          },
        },
      },
    });
  }
  
}
